import {useTranslate} from "../../../../../hooks";
import {FC, useState} from "react";
import i18n from "../../../../../utils/i18n";
import {Card, Progress, Spin, Typography} from "antd";
import {Link} from "react-router-dom";
import {CountryFlag, Popover} from "../../../../../componets/ui";
import camera from "../../../../../assets/icons/camera.svg";
import {Trans} from "react-i18next";
import Utils from "../../../../../utils/utils";
import {Project, RowPropsT} from "../../../../../models";
import styles from './index.module.scss';

export const ProjectDetails: FC<{ item: Project }> = ({ item }) => {
	const {
		filledText,
		interestRateAnnualText,
		projectAmountText,
		investmentPeriodText,
		viewProjectText,
		riskLevelText,
	} = useTranslate([
		'filledText',
		'investmentPeriodText',
		'projectAmountText',
		'interestRateAnnualText',
		'viewProjectText',
		'riskLevelText',
	]);
	const [loading, setLoading] = useState(true);
	const percentValue = (+item.investedAmount / +item.assignedAmount) * 100;
	const percent = percentValue === 0 ? 0 : percentValue.toFixed(2);
	const getParamValue = (key: string, fallback: any) => {
		const param = item.params.find((el) => el.pledgeKey === key && el.language === i18n.language);
		if (param !== undefined) {
			return param.description;
		}
		return fallback;
	}
	return (
		<div className={`primaryMarket__itemWrapper ${styles.root}`}>

			<Card className={`primaryMarket__item ${styles.card}`} bordered={false}>
				<Link to={`/account/projects/${item.loanId}`} style={{cursor: 'pointer'}}>
					<div className="primaryMarket__linkWrapper">
						<div className="primaryMarket__photo">
							<div className="primaryMarket__row">
								{item.riskLevel && (
									<div className="primaryMarket__risk">
										<Popover
											content={riskLevelText}
											trigger="hover"
											className="primaryMarket__popover"
											placement="bottom"
										>
											<div className="primaryMarket__rickContent">{item.riskLevel}</div>
										</Popover>
									</div>
								)}
								<CountryFlag country={item.country.iso} />
							</div>
							{loading && (
								<div className="primaryMarket__spinner">
									<Spin size="large" />
								</div>
							)}
							<img
								style={{ maxWidth: 230 }}
								onLoad={() => {
									setLoading(false);
								}}
								src={item.mainPhoto}
								alt={item.title}
								onError={({ currentTarget }) => {
									currentTarget.onerror = null;
									currentTarget.className = 'primaryMarket__image-error';
									currentTarget.src = camera;
								}}
							/>
						</div>
						<div className="primaryMarket__info">
							<div className="primaryMarket__block">
								<Typography.Title level={5}>{item.title}</Typography.Title>
								<div className="primaryMarket__progress">
									<Progress showInfo={false} percent={+percent} strokeColor="#65ABFF" />
									<div className="primaryMarket__row">
										<Typography.Text type="secondary">
											{percent}% {filledText}
										</Typography.Text>
										<Typography.Text type="secondary">
											<Trans
												i18nKey="leftText"
												values={{ money: Utils.moneyFormat(+item.availableToInvest) }}
											/>
										</Typography.Text>
									</div>
								</div>
							</div>
							<div className="primaryMarket__line" />
							<div className="primaryMarket__block">
								<Row title={interestRateAnnualText} value={getParamValue('interestRate', item.interest)} />
								<Row title="LTV" value={getParamValue('ltvRate', item.ltv)} />
								<Row
									title={projectAmountText}
									value={Utils.moneyFormat(+item.assignedAmount)}
								/>
								<Row title={investmentPeriodText} value={getParamValue('investmentPeriod', item.investmentPeriod)} />
							</div>
							<div className="primaryMarket__button">
								<div className="primaryMarket__link">{viewProjectText}</div>
							</div>
						</div>
					</div>
				</Link>
			</Card>
		</div>
	);
}

export const Row: FC<RowPropsT> = ({ title, value }) => {
	return (
		<div className="primaryMarket__row">
			<Typography.Text className="primaryMarket__rowTitle" type="secondary">
				{title}
			</Typography.Text>
			<Typography.Text className="primaryMarket__infoText">{value}</Typography.Text>
		</div>
	);
};

export default ProjectDetails;
